import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const ACCOUNT_VIDEO_REPORT_ID = `account${VIDEO_CAMPAIGN_SUFFIX}`;
